<template>
  <section id="about-us" class="about-section">
    <div class="bg-pattern"></div>
    <div class="floating-circle circle1"></div>
    <div class="floating-circle circle2"></div>
    <div class="floating-circle circle3"></div>
    
    <div class="section-header" :class="{ 'animate': isInView }">
      <div class="header-line"></div>
      <h2 class="section-title">About <span>Eduval</span></h2>
      <div class="header-line"></div>
    </div>
    
    <div class="cards-container">
      <div class="card vision-card" 
        :class="{ 'animate': isInView }" 
        @mousemove="handleMouseMove" 
        @mouseleave="handleMouseLeave"
        ref="visionCard">
        <div class="card-content">
          <div class="card-icon">
            <i class="fas fa-eye"></i>
          </div>
          <h3>Our Vision</h3>
          <p>To arrive to an organized and accountable global system, that can effectively support strategic planning, performance management, and quality assurance.</p>
          <div class="card-shine"></div>
        </div>
      </div>
      
      <div class="card about-card" 
        :class="{ 'animate': isInView }" 
        @mousemove="handleMouseMove" 
        @mouseleave="handleMouseLeave"
        ref="aboutCard">
        <div class="card-content">
          <div class="card-icon">
            <i class="fas fa-building"></i>
          </div>
          <h3>About Us</h3>
          <p>A subsidiary of BME Holding Group - KSA, our team is comprised of professionals with extensive experience in performance management, higher education, academic administration, and strategic planning.</p>
          <p class="secondary-text">We provide personalized approaches and offer advanced solutions to complex issues. We believe in working closely with our clients to help them realize their objectives by leveraging technology and knowledge transfer.</p>
          <div class="card-shine"></div>
        </div>
      </div>
      
      <div class="card mission-card" 
        :class="{ 'animate': isInView }" 
        @mousemove="handleMouseMove" 
        @mouseleave="handleMouseLeave"
        ref="missionCard">
        <div class="card-content">
          <div class="card-icon">
            <i class="fas fa-rocket"></i>
          </div>
          <h3>Our Mission</h3>
          <p>To advance institutions with the knowledge, tools, and systems designed to streamline processes, enhance their effectiveness, and make them more efficient.</p>
          <div class="card-shine"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutUsSection',
  data() {
    return {
      isInView: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.checkView);
    // Initial check
    this.checkView();
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.checkView);
  },
  methods: {
    checkView() {
      const section = document.querySelector('.about-section');
      if (!section) return;
      
      const position = section.getBoundingClientRect();
      
      // Check if section is in viewport
      if (position.top < window.innerHeight && position.bottom >= 0) {
        this.isInView = true;
      }
    },
    handleMouseMove(e) {
      const card = e.currentTarget;
      const cardRect = card.getBoundingClientRect();
      const x = e.clientX - cardRect.left;
      const y = e.clientY - cardRect.top;
      
      const centerX = cardRect.width / 2;
      const centerY = cardRect.height / 2;
      
      const rotateX = (y - centerY) / 10;
      const rotateY = (centerX - x) / 10;
      
      card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.05, 1.05, 1.05)`;
      
      // Position the shine effect
      const shine = card.querySelector('.card-shine');
      shine.style.opacity = '0.15';
      shine.style.transform = `translate(${x}px, ${y}px)`;
    },
    handleMouseLeave(e) {
      const card = e.currentTarget;
      card.style.transform = 'perspective(1000px) rotateX(0) rotateY(0) scale3d(1, 1, 1)';
      
      const shine = card.querySelector('.card-shine');
      shine.style.opacity = '0';
    }
  }
}
</script>

<style scoped>
.about-section {
  padding: 8rem 2rem;
  background-color: #1e1e1e;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    radial-gradient(rgba(209, 192, 110, 0.1) 2px, transparent 2px),
    radial-gradient(rgba(209, 192, 110, 0.05) 2px, transparent 2px);
  background-size: 50px 50px, 100px 100px;
  background-position: 0 0, 25px 25px;
  opacity: 0.4;
  z-index: 0;
}

.floating-circle {
  position: absolute;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(209, 192, 110, 0.3), rgba(224, 211, 148, 0.1));
  opacity: 0.4;
  filter: blur(20px);
}

.circle1 {
  width: 300px;
  height: 300px;
  top: -100px;
  right: -50px;
  animation: float1 18s infinite ease-in-out;
}

.circle2 {
  width: 200px;
  height: 200px;
  bottom: 100px;
  left: -50px;
  animation: float2 15s infinite ease-in-out;
}

.circle3 {
  width: 150px;
  height: 150px;
  bottom: -50px;
  right: 30%;
  animation: float3 12s infinite ease-in-out;
}

@keyframes float1 {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(50px, 50px) rotate(180deg);
  }
}

@keyframes float2 {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  50% {
    transform: translate(30px, -50px) rotate(-180deg);
  }
}

@keyframes float3 {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  33% {
    transform: translate(30px, 30px) rotate(90deg);
  }
  66% {
    transform: translate(-30px, 50px) rotate(180deg);
  }
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 5rem;
  position: relative;
  z-index: 2;
  opacity: 0;
  transform: translateY(30px);
  transition: all 1s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.section-header.animate {
  opacity: 1;
  transform: translateY(0);
}

.header-line {
  height: 2px;
  width: 0;
  background: linear-gradient(90deg, transparent, #d1c06e, transparent);
  transition: width 1.5s ease;
  margin: 0 1.5rem;
}

.section-header.animate .header-line {
  width: 100px;
}

.section-title {
  font-size: 3rem;
  color: #fff;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  white-space: nowrap;
}

.section-title span {
  color: #d1c06e;
  position: relative;
  display: inline-block;
}

.section-title span::after {
  content: '';
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 0;
  height: 3px;
  background: #d1c06e;
  transition: width 0.5s ease 1s;
}

.section-header.animate .section-title span::after {
  width: 100%;
}

.cards-container {
  display: flex;
  justify-content: center;
  gap: 2.5rem;
  max-width: 1400px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
  perspective: 1000px;
}

.card {
  flex: 1;
  min-width: 280px;
  max-width: 400px;
  min-height: 420px;
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  opacity: 0;
  transform: translateY(80px);
  transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
  transform-style: preserve-3d;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3);
}

.card.animate {
  opacity: 1;
  transform: translateY(0);
}

.vision-card.animate {
  transition-delay: 0.2s;
}

.about-card.animate {
  transition-delay: 0.4s;
}

.mission-card.animate {
  transition-delay: 0.6s;
}

.card-content {
  height: 100%;
  width: 100%;
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 2.5rem;
  transition: all 0.5s ease;
  overflow: hidden;
}

.card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(209, 192, 110, 0.15) 0%,
    rgba(209, 192, 110, 0.05) 100%
  );
  z-index: -1;
}

.card-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d1c06e, #e0d394);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  position: relative;
  box-shadow: 0 8px 20px rgba(209, 192, 110, 0.3);
}

.card-icon::after {
  content: '';
  position: absolute;
  top: -5px;
  left: -5px;
  right: -5px;
  bottom: -5px;
  border-radius: 50%;
  border: 2px solid rgba(209, 192, 110, 0.3);
  animation: pulse-border 2s infinite;
}

.card-icon i {
  font-size: 1.8rem;
  color: #fff;
}

.card h3 {
  font-size: 1.8rem;
  color: #d1c06e;
  margin-bottom: 1.2rem;
  position: relative;
  display: inline-block;
}

.card h3::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 40px;
  height: 3px;
  background: linear-gradient(to right, #d1c06e, rgba(209, 192, 110, 0.3));
  transition: width 0.3s ease;
}

.card:hover h3::after {
  width: 100%;
}

.card p {
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.6;
  font-size: 1.05rem;
  margin-bottom: 1rem;
}

.card .secondary-text {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.6);
}

.card-shine {
  position: absolute;
  width: 150px;
  height: 150px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0) 70%
  );
  border-radius: 50%;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s;
  will-change: transform, opacity;
  transform: translate(-50%, -50%);
}

@keyframes pulse-border {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  70% {
    transform: scale(1.1);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

@media (max-width: 1100px) {
  .cards-container {
    flex-wrap: wrap;
  }
  
  .card {
    min-width: 300px;
    flex: 1 1 40%;
  }
}

@media (max-width: 768px) {
  .about-section {
    padding: 6rem 1.5rem;
  }
  
  .section-title {
    font-size: 2.2rem;
  }
  
  .cards-container {
    flex-direction: column;
    align-items: center;
  }
  
  .card {
    width: 100%;
    max-width: 400px;
  }
  
  .header-line {
    display: none;
  }
}
</style> 